import { NetworkService } from './services/network.service';

import { Component } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { MenuController, NavController, Platform } from '@ionic/angular';
import { InactivityService } from './services/inactivity.service';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  public appPages = [{
    title: 'Home',
    url: '/home',
    icon: 'home'
  },
  {
    title: 'Agenda',
    url: '/lista-agenda-doctor',
    icon: 'list'
  }, {
    title: 'Expedientes',
    url: '/buscador-citas',
    icon: 'folder-open'
  }];

  constructor(
    private platform: Platform,
    private menu: MenuController,
    private navController: NavController,
    private splashScreen: SplashScreen,
    private networkService: NetworkService,
    private inactivityService: InactivityService
  ) {
    this.initializeApp();
    this.inactivityService.initializeInactivityTracking();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.platform.backButton.subscribeWithPriority(9999, () => {
        document.addEventListener('backbutton', (event) => {
          event.preventDefault();
          event.stopPropagation();
          console.log('Se presiono back');
        }, false);
      });
      this.networkService.checkConnectionBehaviour();
      this.splashScreen.hide();
    });
  }

  openFirst() {
    this.menu.enable(true, 'first');
    this.menu.open('first');
  }

  openEnd() {
    this.menu.open('end');
  }

  openCustom() {
    this.menu.enable(true, 'custom');
    this.menu.open('custom');
  }

  salir() {
    localStorage.removeItem('logged');
    this.navController.navigateRoot(['/login']);
  }
}
